export default {
    name: 'sampleLog',
    serverName: '/api/v1/agrochemical_analysis/analysis/',
    apiUrl: '/api/v1/agrochemical_analysis/analysis/',
    fileUploadUrl: '/api/v1/agrochemical_analysis/protocol/upload_protocol/'
};